var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStandard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6665 3.36719C11.4832 3.36719 4.0332 10.8172 4.0332 20.0005C4.0332 29.1839 11.4832 36.6339 20.6665 36.6339C29.8499 36.6339 37.2999 29.1839 37.2999 20.0005C37.2999 10.8172 29.8499 3.36719 20.6665 3.36719ZM19.7999 29.8005V22.9005H15.3665C14.7499 22.9005 14.3332 22.2339 14.6332 21.6839L20.7665 9.73385C21.1499 8.95052 22.3332 9.23385 22.3332 10.1172V17.1005H26.5665C27.1832 17.1005 27.5832 17.7505 27.3165 18.3005L21.3832 30.1672C20.9832 30.9672 19.7999 30.6839 19.7999 29.8005Z",
    fill: "#1737E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandard);
export default __webpack_public_path__ + "static/media/standard.6e6fb50edc9db0cb1f6b344537fb9a00.svg";
export { ForwardRef as ReactComponent };